import spinnerConfiguration from '@/assets/spinnerConfiguration.json';

const initState = {
  galleryImageList: [],
  valid: false,
  activeImageIndex: 0,
  loaded: false,
  promoBanner: '',
  spinnerThumbnail: {},
  productSpinnerImages: {},
  loadedSpinnerImages: {},
  startedPreloading: {},
  viewerOpen: false,
};

export default {
  state: { ...initState },
  getters: {
    getIsMultiImageGallery(state, getters) {
      return getters.getGalleryImageList.length > 1;
    },
    getGalleryImageList(state) {
      return state.galleryImageList;
    },
    getActiveImageIndex(state) {
      return state.activeImageIndex;
    },
    getValid(state) {
      return state.valid;
    },
    getGalleryLoaded(state) {
      return state.loaded;
    },
    getPromoBanner(state) {
      return state.promoBanner;
    },
    getSpinnerThumbnail(state) {
      return state.spinnerThumbnail;
    },
    getSpinnerThumbnailBySku(state, getters) {
      return (sku) => getters.getSpinnerThumbnail[sku];
    },
    getProductSpinnerImages(state) {
      return state.productSpinnerImages;
    },
    getProductSpinnerImagesBySku(state, getters) {
      return (sku) => getters.getProductSpinnerImages[sku];
    },
    getLoadedSpinnerImages(state) {
      return state.loadedSpinnerImages;
    },
    getStartedPreloading(state) {
      return state.startedPreloading;
    },
    getStartedPreloadingBySku(state, getters) {
      return (sku) => getters.getStartedPreloading[sku];
    },
    getViewerOpen(state) {
      return state.viewerOpen;
    },
  },
  mutations: {
    setGalleryImageList(state, payload) {
      state.galleryImageList = payload;
    },
    setActiveImageIndex(state, payload) {
      state.activeImageIndex = payload;
    },
    setValid(state, payload) {
      state.valid = payload;
    },
    setGalleryLoaded(state, payload) {
      state.loaded = payload;
    },
    setPromoBanner(state, payload) {
      state.promoBanner = payload;
    },
    setSpinnerThumbnail(state, payload) {
      const { sku, thumbnail } = payload;
      const { image, altTag } = thumbnail;
      state.spinnerThumbnail = {
        ...state.spinnerThumbnail,
        [sku]: {
          imageSrc: image,
          altText: altTag,
          caption: null,
          type: '360',
        },
      };
    },
    setInitSpinnerImages(state, payload) {
      const { sku, gallery } = payload;
      state.productSpinnerImages = {
        ...state.productSpinnerImages,
        [sku]: gallery,
      };
    },
    setLoadedSpinnerImages(state, payload) {
      const { sku, value } = payload;
      state.loadedSpinnerImages = { ...state.loadedSpinnerImages, [sku]: value };
    },
    setStartedPreloading(state, payload) {
      const { sku, value } = payload;
      state.startedPreloading = { ...state.startedPreloading, [sku]: value };
    },
    setViewerOpen(state, payload) {
      state.viewerOpen = payload;
    },
  },
  actions: {
    updateActiveImageIndex({ commit }, payload) {
      commit('setActiveImageIndex', payload);
    },
    setGallery({ commit }, payload) {
      const { defaultImage, gallery, valid } = payload;
      if (defaultImage && gallery && valid) {
        const imageList = [defaultImage, ...gallery];

        imageList.forEach((imageObj) => {
          // If already fixed, do nothing
          if (imageObj.imageSrc && imageObj.altText) return;

          imageObj.imageSrc = imageObj.image;
          delete imageObj.image;
          imageObj.altText = imageObj.altTag;
          delete imageObj.altTag;
        });

        commit('setGalleryImageList', imageList);
      } else {
        commit('setGalleryLoaded', true);
      }

      commit('setActiveImageIndex', 0);
      commit('setValid', valid);
    },
    setGalleryLoaded({ commit }, payload) {
      commit('setGalleryLoaded', payload);
    },
    setPromoBanner({ commit }, payload) {
      commit('setPromoBanner', payload);
    },
    initSpinner({ commit, getters }, payload) {
      const locale = getters.getLocale;
      const sku = getters.getPartNumber;
      const skuConfig = spinnerConfiguration[sku];

      // TODO: Remove this once we go global with it or when WPC returns it
      if (locale !== 'en-US') return;

      // If no spinner configuration in bootstrap check local config
      if (!payload) {
        // No local configuration found, simply return
        if (!skuConfig) return;
      }

      const gallery = payload ? payload.gallery : skuConfig.gallery;
      const thumbnail = payload ? payload.thumbnail : skuConfig.thumbnail;

      commit('setSpinnerThumbnail', {
        sku,
        thumbnail,
      });
      commit('setInitSpinnerImages', {
        sku,
        gallery,
      });
    },
    setLoadedSpinnerImages({ commit }, payload) {
      commit('setLoadedSpinnerImages', payload);
    },
    setStartedPreloading({ commit }, payload) {
      commit('setStartedPreloading', payload);
    },
    setViewerOpen({ commit }, payload) {
      commit('setViewerOpen', payload);
    },
    removeBrokenImage({ commit, getters }, payload) {
      const sku = getters.getPartNumber;
      const newImages = getters
        .getProductSpinnerImagesBySku(sku)
        .filter((image) => image !== payload);

      commit('setInitSpinnerImages', {
        sku,
        gallery: newImages,
      });
    },
  },
};
